const INITIAL_STATE = {
  waveDocumentsList: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_WAVE_DOCUMENTS': {
      return { ...state, waveDocumentsList: action.waveDocuments };
    }
    default:
      return state;
  }
};